import { User } from "./User.model";

export class TrainerMaster{
    public trainerMasterId:number;
    public trainerName:String;
    public userId:number;
public isDelete:string;
public isDeactive:string;
public errorMessage:string;
public pageNumber :number;
public pageSize:number;
public user:User;
}